module.exports = __webpack_public_path__ + "img/disable-DandDs.6cc9622a.svg";